export enum ROUTES_DASHBOARD {
  USERS = 'users',
  OFFICES = 'offices',
  CONTRACTS = 'contracts',
  STADISTICS = 'stadistics',
  MY_DAY = 'my-day',
  PROFILE = 'profile',
  OPERATIONS = 'operations',
  TEAMS = 'teams',
  PROSPECTION = 'prospection',
  MANAGEMENT = 'management',
  LIQUIDATIONS = 'liquidations',
  TOOLS = 'tools'
}
